<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-full"
    title="Microsoft VNコネクト一覧"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container fluid>
            <!-- 回線情報 -->
            <div>
              <h3>回線情報</h3>
            </div>
            <v-row class="my-1 ml-3">
              <v-col cols="3">
                <app-label-group
                  label="回線番号"
                  :value="vnConnectList.enumber"
                />
              </v-col>
              <v-col cols="3">
                <app-label-group
                  label="アクセス回線メニュー"
                  :value="
                    $filter.enumTo(
                      vnConnectList.accessType,
                      'cloudVn_accessType'
                    ) +
                    '(' +
                    $filter.bandwidthTo(accessLineMenuBandwidth, 'Mbps') +
                    ')'
                  "
                />
              </v-col>
              <v-col cols="3">
                <app-label-group
                  label="事業所名"
                  :value="vnConnectList.office"
                />
              </v-col>
            </v-row>

            <!-- クラウド情報 -->
            <h3>クラウド情報</h3>
            <v-row class="mt-1 ml-3">
              <v-col cols="3">
                <app-label-group
                  label="種別"
                  :value="$filter.cloudServiceMenuTo(cloudServiceMenu)"
                />
              </v-col>
              <v-col cols="3">
                <app-label-group
                  label="帯域"
                  :value="$filter.bandwidthTo(vnConnectList.bandwidth, 'Mbps')"
                />
              </v-col>
              <v-col cols="3">
                <app-label-group label="増速可能帯域">
                  <template #value>
                    <div class="ml-3">
                      Private Peering:{{ privatePeeringBandwidth }}
                    </div>
                    <div class="ml-3">
                      Microsoft Peering:{{ msPeeringBandwidth }}
                    </div>
                  </template>
                </app-label-group>
              </v-col>
              <v-col v-if="oldKeyStatus === 'SUCCESS'" cols="3">
                <app-label-group
                  label="ServiceKey(ロケーション)"
                  :value="`${formServiceKey.serviceKey}(${$filter.enumTo(formServiceKey.location, 'location')})`"
                />
              </v-col>
            </v-row>

            <!-- 回線情報取得 -->
            <template v-if="oldKeyStatus !== 'SUCCESS'">
              <h3>
                回線情報取得
                <span class="form-status">
                  {{
                    $filter.enumTo(vnConnectList.keyStatus, "cloudVn_keyStatus")
                  }}
                </span>
                <v-tooltip
                  location="top"
                  max-width="300px"
                  content-class="rounded badge-popover"
                >
                  <template v-slot:activator="{ props }">
                    <v-icon
                      v-bind="props"
                      icon="$mdiInformationOutline"
                      class="badge-info ml-2 pb-1"
                    ></v-icon>
                  </template>
                  <div>
                    <span class="msg-pre-line">{{
                      "サービスキーとロケーションを選択して情報取得したのちにVNコネクトの設定ができる。\n一度情報取得後は変更不可。\n" +
                      "1. Microsoft Azureで作成したExpressRouteのプロバイダを「KDDICORPORATION」で設定していること\n" +
                      "2. Microsoft Azureで作成したExpressRouteのピアリングの場所と作成したいVNコネクトのロケーションが一致していること\n" +
                      "・ピアリングの場所が「Tokyo2」の場合はロケーションを東日本で作成\n" +
                      "・ピアリングの場所が「Osaka」の場合はロケーションを西日本で作成\n" +
                      "3. ハイフンを省略せずサービスキーを入力していること"
                    }}</span>
                  </div>
                </v-tooltip>
              </h3>
              <v-row class="mt-1">
                <v-col>
                  <validation-observer v-slot="{ handleSubmit }" as="div">
                    <v-form
                      novalidate
                      @submit.stop.prevent="handleSubmit(submit)"
                    >
                      <v-row>
                        <v-col cols="3">
                          <validation-provider
                            name="ServiceKey"
                            label="ServiceKey"
                            :rules="{ required: true }"
                            v-slot="{ componentField, errorMessage, meta }"
                            v-model="formServiceKey.serviceKey"
                          >
                            <app-label-group label="ServiceKey:" />
                            <app-form-input
                              :disabled="isDisabledFormServiceKey"
                              v-bind="componentField"
                              :error-messages="errorMessage"
                              :field-meta="meta"
                            />
                          </validation-provider>
                        </v-col>
                        <v-col cols="2">
                          <validation-provider
                            v-model="formServiceKey.location"
                            name="location"
                            label="ロケーション"
                            v-slot="{ componentField, meta }"
                          >
                            <app-label-group label="ロケーション:" />
                            <app-select
                              :items="locationOptions"
                              :disabled="isDisabledFormServiceKey"
                              v-bind="componentField"
                              :field-meta="meta"
                            >
                            </app-select>
                          </validation-provider>
                        </v-col>
                        <v-col class="d-flex align-center">
                          <v-progress-circular
                            indeterminate
                            color="primary"
                            class="ma-1"
                            v-if="vnConnectList.keyStatus === 'ACQUIRING'"
                          />
                          <v-btn
                            type="submit"
                            :disabled="isDisabledFormServiceKey"
                            color="primary"
                            >取得</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-form>
                  </validation-observer>
                </v-col>
              </v-row>
            </template>

            <!-- VNコネクト情報 -->
            <template v-if="vnConnectList.keyStatus === 'SUCCESS'">
              <div class="d-flex justify-space-between mb-4">
                <div class="d-flex align-end">
                  <h3>VNコネクト情報</h3>
                </div>
                <div class="d-flex ga-2">
                  <v-btn
                    color="primary"
                    @click="register"
                    :disabled="!isAddVnConnect"
                    v-permission.config
                    >追加</v-btn
                  >
                  <v-btn
                    color="primary"
                    @click="modifyStatus(true)"
                    v-permission.config
                    >有効</v-btn
                  >
                  <v-btn
                    color="primary"
                    @click="modifyStatus(false)"
                    v-permission.config
                    >無効</v-btn
                  >
                </div>
              </div>
              <v-alert
                v-if="alertMsg"
                class="my-2 text-left"
                :text="alertMsg"
              ></v-alert>
              <div v-permission.config class="text-left">
                <v-alert v-if="hasCloudVnResetting" class="my-2" color="red">{{
                  $filter.message("vn_connect_has_resetting")
                }}</v-alert>
              </div>
              <app-table
                primary-key="cloudVnConnectCommon.cloudServiceType"
                :fields="vnConnects.fields"
                :items="vnConnectList.cloudVnConnectsList"
                :selectable="selectable"
                v-model="vnConnects.selected"
                :hover="true"
                v-model:table-sort-by="vnConnects.sortBy"
                @click:row="showConnectionDetails"
                :td-class="cellClass"
              >
                <template #cell(wnumber)="{ item }">
                  {{ item.cloudVnConnectAct.wnumber }}<br />
                  {{ item.cloudVnConnectSby.wnumber }}
                </template>
                <template #cell(vnConnectName)="{ item }">
                  {{ item.cloudVnConnectAct.vnConnectName }}<br />
                  {{ item.cloudVnConnectSby.vnConnectName }}
                </template>
                <template #cell(isVnConnectStatus)="{ item }">
                  {{
                    $filter.enumTo(
                      item.cloudVnConnectAct.isVnConnectStatus,
                      "enable"
                    )
                  }}<br />
                  {{
                    $filter.enumTo(
                      item.cloudVnConnectSby.isVnConnectStatus,
                      "enable"
                    )
                  }}
                </template>
                <template #cell(bandwidth)="{ item }">
                  {{ item.cloudVnConnectCommon.bandwidthType }}({{
                    $filter.bandwidthTo(
                      item.cloudVnConnectCommon.bandwidth,
                      "Mbps"
                    )
                  }})
                </template>
                <template #cell(routingType)="{ item }">
                  {{ item.cloudVnConnectCommon.routingType }}
                </template>
                <template #cell(description)="{ item }">
                  {{
                    $filter.emptyTo(item.cloudVnConnectCommon.description, "-")
                  }}
                </template>
              </app-table>
            </template>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { NullableProperty } from "@/shims-vue";
import type { CloudLine, Line } from "@/apis/CloudLineApi";
import type { AppTableHeader, SortItem } from "@/components/AppTable.vue";
import type {
  CloudVnMs,
  CloudVnMsList,
  PostServiceKey,
} from "@/apis/CloudVnMsApi";
import MultiCloudMsVnLineEdit from "@/modals/multicloud/ms/MultiCloudMsVnLineEdit.vue";
import MultiCloudVNConnectStatusModify from "@/modals/multicloud/MultiCloudVNConnectStatusModify.vue";
import MultiCloudMsVnConnectionReference from "@/modals/multicloud/ms/MultiCloudMsVnConnectionReference.vue";

type CloudVnMsItem = CloudVnMsList["cloudVnConnectsList"][0];

export default defineComponent({
  name: "MultiCloudMsVnConnectionList",
  props: {
    /** クラウド回線SEQ */
    cloudLineSeq: {
      type: String as PropType<string>,
      required: true,
    },
    /** 該当クラウドメニューの設定未完了VNコネクト有無 */
    hasCloudVnResetting: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    cloudServiceMenu: {
      type: String as PropType<CloudLine["cloudServiceMenu"]>,
      required: true,
    },
    /** アクセス回線メニューの帯域 */
    accessLineMenuBandwidth: {
      type: Object as PropType<Line["bandwidth"]>,
      required: true,
    },
  },
  data() {
    return {
      vnConnectList: {} as CloudVnMsList,
      formServiceKey: {} as NullableProperty<PostServiceKey>,
      locationOptions: [
        { value: "EAST_JAPAN", title: "東日本" },
        { value: "WEST_JAPAN", title: "西日本" },
      ],
      vnConnects: {
        sortBy: { key: "wnumber", order: "asc" } as SortItem,
        fields: [
          {
            key: "wnumber",
            title: "VNコネクト番号(Act/Sby)",
            width: "150px",
            sortable: true,
            sortByFormatted: true,
            formatter: (_v, _k, item: CloudVnMsItem) => {
              return item.cloudVnConnectAct.wnumber;
            },
          },
          {
            key: "vnConnectName",
            title: "VNコネクト名(Act/Sby)",
            width: "140px",
            sortable: true,
            sortByFormatted: true,
            formatter: (_v, _k, item: CloudVnMsItem) => {
              return item.cloudVnConnectAct.vnConnectName;
            },
          },
          {
            key: "isVnConnectStatus",
            title: "有効/無効(Act/Sby)",
            width: "110px",
            sortable: true,
            sortByFormatted: true,
            formatter: (_v, _k, item: CloudVnMsItem) => {
              return this.$filter.enumTo(
                item.cloudVnConnectAct.isVnConnectStatus,
                "enable"
              );
            },
          },
          {
            key: "vpnVnCode",
            title: "接続先VPN/VNコード",
            width: "185px",
            sortable: true,
            sortByFormatted: true,
            formatter: (_v, _k, item: CloudVnMsItem) => {
              if (item.cloudVnConnectCommon.vpnVnCode.startsWith("D")) {
                return `${item.cloudVnConnectCommon.vpnVnCode}(
                  ${item.cloudVnConnectCommon.vnType}
                )`;
              }
              return item.cloudVnConnectCommon.vpnVnCode;
            },
          },
          {
            key: "bandwidth",
            title: "品目",
            width: "160px",
            sortable: true,
            sortByFormatted: true,
            formatter: (_v, _k, item: CloudVnMsItem) => {
              return this.$filter.bandwidthToBps(
                item.cloudVnConnectCommon.bandwidth
              );
            },
          },
          { key: "routingType", title: "ルーティング種別", width: "155px" },
          { key: "description", title: "備考", width: "200px" },
        ] as AppTableHeader<CloudVnMs>[],
        selected: [] as CloudVnMs[],
      },
      alertMsg: null as string | null,
      /** ポーリング情報. nullの場合はポーリングしてない */
      pooling: null as null | number | NodeJS.Timeout,
      privatePeeringBandwidth: "" as string,
      msPeeringBandwidth: "" as string,
      isLoaded: false,
      oldKeyStatus: "" as "UNEXECUTED" | "ACQUIRING" | "SUCCESS" | "FAILED",
    };
  },
  computed: {
    /** true: 一覧選択可能, false: 不可 */
    selectable(): boolean {
      return this.$service.permission.hasAuthority("CONFIG");
    },
    /** true: 回線情報取得の編集不可, false: 編集可能 */
    isDisabledFormServiceKey(): boolean {
      switch (this.vnConnectList.keyStatus) {
        case "ACQUIRING":
        case "SUCCESS":
          return true;
        default:
          return false;
      }
    },
    /** true: VNコネクト追加可能, false: 追加不可 */
    isAddVnConnect(): boolean {
      return this.vnConnectList.cloudVnConnectsList.length <= 1;
    },
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
    this.privatePeeringBandwidth = this.increaseBandwidth("PRIVATE_PEERING");
    this.msPeeringBandwidth = this.increaseBandwidth("MICROSOFT_PEERING");
    this.oldKeyStatus = this.vnConnectList.keyStatus;

    // 取得中状態の場合はポーリングスタート
    if (this.vnConnectList.keyStatus === "ACQUIRING") {
      this.startPooling();
    }
  },
  unmounted() {
    if (this.pooling) {
      clearInterval(this.pooling);
    }
  },
  methods: {
    /** 読み込み */
    async load(loading = true) {
      this.vnConnectList = await this.$api.cloudVnMs.getVnConnects(
        this.cloudLineSeq,
        loading
      );
      this.formServiceKey = {
        serviceKey: this.vnConnectList.serviceKey,
        location: this.vnConnectList.location ?? "EAST_JAPAN",
      };
    },

    /** 取得中状態の間は読み込みを定期的に行うポーリング処理を開始 */
    startPooling() {
      if (this.pooling) {
        clearInterval(this.pooling);
      }
      this.pooling = setInterval(async () => {
        await this.load(false);
        if (this.vnConnectList.keyStatus !== "ACQUIRING" && this.pooling) {
          clearInterval(this.pooling);
        }
      }, 5000);
    },

    /** 増速可能帯域計算 */
    increaseBandwidth(cloudServiceType: string): string {
      const limitBandwidthMbps =
        (this.$filter.bandwidthToBps(this.vnConnectList.bandwidth) ?? 0) /
        1000 /
        1000;
      const targetCloud = this.vnConnectList.cloudVnConnectsList.find(
        (e) => e.cloudVnConnectCommon.cloudServiceType === cloudServiceType
      );
      const targetBandwidthMbps = targetCloud
        ? (this.$filter.bandwidthToBps(
            targetCloud.cloudVnConnectCommon.bandwidth
          ) ?? 0) /
          1000 /
          1000
        : 0;
      // 該当VNコネクトが存在しない場合
      if (targetBandwidthMbps == 0) {
        // 固定文字列「未設定」を返却する
        return "未設定";
      }
      // 該当VNコネクトが存在する場合、増速可能帯域を計算する
      const diffBandwidthMbps = limitBandwidthMbps - targetBandwidthMbps;
      if (diffBandwidthMbps >= 1000) {
        return this.$filter.bandwidthTo({
          value: diffBandwidthMbps / 1000,
          unit: "GBPS",
        });
      } else {
        return this.$filter.bandwidthTo({
          value: diffBandwidthMbps,
          unit: "MBPS",
        });
      }
    },

    /** 回線情報取得 */
    async submit() {
      await this
        .$confirm(`サービスキーで回線情報を取得する前に、必ず以下確認をしてください。
      1. Microsoft Azureで作成したExpressRouteのプロバイダを「KDDI CORPORATION」で設定していること
      2. Microsoft Azureで作成したExpressRouteのピアリングの場所と作成したいVNコネクトのロケーションが一致していること
      ・ピアリングの場所が「Tokyo2」の場合はロケーションを東日本で作成
      ・ピアリングの場所が「Osaka」の場合はロケーションを西日本で作成
      3. ハイフンを省略せずサービスキーを入力していること
      `);
      await this.$api.cloudVnMs.postServiceKey(
        this.cloudLineSeq,
        this.formServiceKey as PostServiceKey
      );
      await this.load();
      this.startPooling();
    },
    /** VNコネクト追加 */
    async register() {
      this.alertMsg = null;
      await this.$modal.show(MultiCloudMsVnLineEdit, {
        cloudVnMsInformation: this.vnConnectList,
        cloudLineSeq: this.cloudLineSeq,
      });
      await (
        this.$refs.modal as typeof VueFinalModal & { ok: () => void }
      ).ok();
    },

    /** 有効/無効 */
    async modifyStatus(isEnabled: boolean) {
      if (this.vnConnects.selected.length === 0) {
        this.alertMsg = this.$filter.message("no_select_data");
        return;
      } else {
        this.alertMsg = null;
      }

      const wNumbers: string[] = await this.$modal.show(
        MultiCloudVNConnectStatusModify,
        {
          enable: isEnabled,
          vnConnects: this.vnConnects.selected,
        }
      );

      if (isEnabled) {
        await this.$api.cloudVnMs.putEnableVnConnect({
          cloudVnConnectList: wNumbers,
          cloudVnMsKeyId: this.vnConnectList.cloudVnMsKeyId,
        });
      } else {
        await this.$api.cloudVnMs.putDisableVnConnect({
          cloudVnConnectList: wNumbers,
          cloudVnMsKeyId: this.vnConnectList.cloudVnMsKeyId,
        });
      }
      await (
        this.$refs.modal as typeof VueFinalModal & { ok: () => void }
      ).ok();
    },

    /** VNコネクト詳細表示 */
    async showConnectionDetails(entity: CloudVnMs) {
      this.alertMsg = null;
      await this.$modal.show(MultiCloudMsVnConnectionReference, {
        wnumber: entity.cloudVnConnectAct.wnumber,
        cloudLineSeq: this.cloudLineSeq,
      });
      await (
        this.$refs.modal as typeof VueFinalModal & { ok: () => void }
      ).ok();
    },

    /** tdにクラスをつける */
    cellClass(field: AppTableHeader<CloudVnMs>): string[] | undefined {
      if (field.key === "description") {
        return ["text-pre-wrap"];
      }
      return undefined;
    },
  },
});
</script>

<style lang="scss" scoped>
.form-status {
  margin-left: 0.5em;
  font-size: 1rem;
  font-weight: normal;
  color: red;
}
.msg-pre-line {
  white-space: pre-line;
}
</style>
